import FeatureIcon from './ListIcons/feature-icon.png';
import GroupIcon from './ListIcons/group-icon.png';
import VisualisedGroupIcon from './ListIcons/visualised-icon.png';
import TextNodeIcon from './ListIcons/text-icon.png';
import ProgressBarIcon from './ListIcons/progress-bar-icon.png';
import ImageNodeIcon from './ListIcons/image-icon.png';
import NodeClosedIcon from './ListIcons/node-closed.png';
import NodeOpenIcon from './ListIcons/node-open.png';
import AddIcon from './ListIcons/add-icon.png';

import EyeOnIcon from './ModuleIcons/eye.png';
import EyeOffIcon from './ModuleIcons/eye_off.png';
import TextLeftAlignIcon from './ModuleIcons/format_align_left.png';
import TextCenterAlignIcon from './ModuleIcons/format_align_center.png';
import TextRightAlignIcon from './ModuleIcons/format_align_right.png';
import AlignTopIcon from './ModuleIcons/vertical_align_top.png';
import AlignCenterIcon from './ModuleIcons/vertical_align_center.png';
import AlignBottomIcon from './ModuleIcons/vertical_align_bottom.png';
import LineSpacingIcon from './ModuleIcons/format_line_spacing.png';
import ChevronDown from './ModuleIcons/keyboard_arrow_down.png';

export const WORKSPACE_LEFT_LIST_ICONS = {
    feature: FeatureIcon,
    basicGroup: GroupIcon,
    visualisedGroup: VisualisedGroupIcon,
    text: TextNodeIcon,
    progressBar: ProgressBarIcon,
    image: ImageNodeIcon,
    nodeClosed: NodeClosedIcon,
    nodeOpen: NodeOpenIcon,
    add: AddIcon,
};

export const WORKSPACE_MODULE_ICONS = {
    eyeOn: EyeOnIcon,
    eyeOff: EyeOffIcon,
    textLeftAlign: TextLeftAlignIcon,
    textCenterAlign: TextCenterAlignIcon,
    textRightAlign: TextRightAlignIcon,
    alignTop: AlignTopIcon,
    alignCenter: AlignCenterIcon,
    alignBottom: AlignBottomIcon,
    lineSpacing: LineSpacingIcon,
    chevronDown: ChevronDown,
};
